// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2H_S-","footer":"ModalError_footer__3Oj0y"};